var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('loadingView',{attrs:{"isVisible":_vm.$root.isLoading}}),(_vm.$root.isGuide)?_c('GuideView'):_vm._e(),(_vm.$root.isAlert)?_c('AlertView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }